import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';
import { useTranslation } from 'react-i18next';

export default function BannerPlayBuilder() {
  const { t } = useTranslation();
  return (
    <Box
      component="section"
      data-banner-playbuilder
      onClick={() => {
        window.location.href = '/playbuilder';
      }}
      sx={{
        width: '100%',
        py: { xs: 1.5, md: 2 },
        px: { xs: 2, md: 4 },
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: '#048cec',
        zIndex: 1200,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: '#0378cc',
        },
        '&:hover > div > div': {
          transform: 'translateX(2px)',
        },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          px: { xs: 0, md: 2 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            transition: 'transform 0.3s ease',
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: { xs: '0.85rem', md: '1.05rem' },
              fontWeight: 600,
              lineHeight: 1.2,
              color: 'white',
            }}
          >
            {t("BannerPlayBuilder00")}
          </Typography>
          <Typography
            component="span"
            sx={{
              fontSize: { xs: '0.75rem', md: '0.95rem' },
              fontWeight: 400,
              opacity: 0.9,
              lineHeight: 1.2,
              color: 'white',
            }}
          >
            {t("BannerPlayBuilder01")}
          </Typography>
          <ArrowOutwardRoundedIcon
            sx={{
              fontSize: '1.1rem',
              color: 'white',
              ml: 0.5,
              transition: 'transform 0.3s ease',
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}

